import BaseContainer from "@base/container/BaseContainer";
import { Signals} from "@/Imports";

import Facade from "@/Facade";
import ScaleManager from "@/stage/ScaleManager";
import Config from "@/config/Config";

export default class ConnectionErrorContainer extends BaseContainer {

  constructor (data) {
    super(data)
    this.init()
  }

  init() {
    Signals.errorMessage.add(this.onConnectionError, this)
    this.visible = false
    const back = new PIXI.Graphics()
    back.beginFill(0x323031)
    back.drawRect(0, 0, ScaleManager.currentSizes.total.width, ScaleManager.currentSizes.total.height)
    back.endFill()
    this.addChild(back)

    this.logo = new PIXI.Sprite(PIXI.Texture.from('preloading/logo'))
    this.addChild(this.logo)
    this.logo.anchor.set(0.5)

    this.logo.position.set(440, 250)
  }

  onConnectionError(data) {
    if(data.msg == "Connection error" || data.type == Config.POPUP_KEYS.SESSION_TIMEOUT)
    this.visible = true
  }

}